module.exports = __webpack_public_path__ + "img/GreenCheck-Icon.edfe5288.svg";